import AllReportsContainer from "../../../Component/Reports/AllReports/AllReports"

const AllPages = () => {
  return (
    <div className='page-body'>
      <AllReportsContainer />
    </div>
  )
}

export default AllPages